import script from "./PhoneStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneStep.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneStep.vue?vue&type=style&index=0&id=25c5fe94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c5fe94"]])

export default __exports__